
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { BusinessDiscount } from '@/hooks/useBusinessDiscount';
import { useDiscountSettings } from '@/hooks/useParameters';
import { getDiscountSelectFields } from '@/utils/discountQueryUtils';

export const useBusinessDiscountHistory = (businessId?: string) => {
  const { shouldDisplayDiscountCode } = useDiscountSettings();
  
  return useQuery({
    queryKey: ['business-discount-history', businessId, shouldDisplayDiscountCode],
    queryFn: async () => {
      if (!businessId) return [];
      
      const selectFields = getDiscountSelectFields(shouldDisplayDiscountCode);
      
      const { data, error } = await supabase
        .from('business_discounts')
        .select(selectFields)
        .eq('business_id', businessId)
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching business discount history:', error);
        throw new Error(error.message);
      }
      
      return data as BusinessDiscount[];
    },
    enabled: !!businessId,
  });
};
